export function checkSelectOptions(options, accessPropertiesToCheck = [], elementsWithoutAccessCheckProperties = []) {
  if (!options) {
    return {
      accessPropertiesToCheck,
      elementsWithoutAccessCheckProperties
    };
  }
  options.forEach(option => {
    if (option.accessCheckProperties) {
      if (!option.dropdownItemId) {
        throw new Error('AccessCheckSelectElementWrapper :: dropdownItemId is required in the option');
      }
      accessPropertiesToCheck.push(Object.assign({}, option.accessCheckProperties, {
        dropdownItemId: option.dropdownItemId
      }));
    } else if (option) {
      elementsWithoutAccessCheckProperties.push(option);
    }
  });
  return {
    accessPropertiesToCheck,
    elementsWithoutAccessCheckProperties
  };
}